import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { TypeHazardCode } from './TypeHazardCode';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class MaterialHazardCode extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   materialHazardCodeId: number;
   materialId: number;
   typeHazardCodeId: string;
   comment: string;
   approved: boolean;
   deletedDate: Date;
   deletedBy: string;
   lMApprovedDate: Date;
   lMApprovedBy: string;
   deleteNextLM: boolean;
   hazardStatement: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   typeHazardCode: TypeHazardCode;
}

